import {ApiRequest, ApiResponse} from "@gongt/ts-stl-library/request/protocol";
import {ERequestType} from "@gongt/ts-stl-library/request/request";

export const DeleteUserUrl = `/do_delete_user`;
export const DeleteUserMethod = ERequestType.TYPE_POST;

export interface DeleteUserBody extends ApiRequest {
	userId?: string;
	email?: string;
	completely?: boolean;
}

export interface DeleteUserResponse extends ApiResponse {
	done: boolean;
	message?: string;
}
